@let tagStatus = form.controls.tagStatus.value;

<div class="flex flex-col gap-6">
    <app-image-viewer [imageUrl]="form.controls.tagImagePath.value" label=""></app-image-viewer>
    <cac-form-builder [options]="form"></cac-form-builder>
</div>
<cac-bottom-controls [form]="form.formGroup" [disabled]="!tagStatus && tagStatus !== 0" (onSubmit)="onSubmit($event)"
    [hideCancel]="true" permission="EditLocationTags"></cac-bottom-controls>